package dev.lingvo.ops.components

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base

val OpsPlatformGridStyle = CssStyle.base {
    Modifier.fillMaxWidth().styleModifier {
        property("display", "grid")
        property("grid-template-columns", "repeat(auto-fit, minmax(min(100%, 280px), 1fr))")
        property("gap", "16px")
    }
}
